import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { answersAPI } from '../services/api';
import { QRCodeCanvas } from 'qrcode.react';

const AnswerForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  const [formData, setFormData] = useState({
    questionText: '',
    answerChoice: '',
    explanation: ''
  });
  const [loading, setLoading] = useState(false);
  const [qrPreview, setQrPreview] = useState('');

  useEffect(() => {
    if (isEdit) {
      fetchAnswer();
    }
  }, [id]);

  const fetchAnswer = async () => {
    try {
      const response = await answersAPI.getById(id);
      const { questionText, answerChoice, explanation } = response.data;
      setFormData({ questionText, answerChoice, explanation });
      setQrPreview(`${window.location.origin}/answer/${response.data.shortId}`);
    } catch (error) {
      console.error('Failed to fetch answer:', error);
      navigate('/dashboard');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isEdit) {
        await answersAPI.update(id, formData);
      } else {
        const response = await answersAPI.create(formData);
        setQrPreview(`${window.location.origin}/answer/${response.data.shortId}`);
      }
      navigate('/dashboard');
    } catch (error) {
      console.error('Failed to save answer:', error);
      alert('Cevap kaydedilemedi. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-6">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-900">
              {isEdit ? 'Cevabı Düzenle' : 'Yeni Cevap Oluştur'}
            </h2>
          </div>

          <form onSubmit={handleSubmit} className="p-6">
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Soru Metni (Opsiyonel)
                </label>
                <textarea
                  name="questionText"
                  value={formData.questionText}
                  onChange={handleChange}
                  rows="3"
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder="Sorunuzu buraya yazın..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Doğru Cevap
                </label>
                <select
                  name="answerChoice"
                  value={formData.answerChoice}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                >
                  <option value="">Seçin</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Açıklama
                </label>
                <textarea
                  name="explanation"
                  value={formData.explanation}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder="Cevabın açıklamasını yazın..."
                />
              </div>

              {qrPreview && (
                <div className="border-t pt-6">
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    QR Kod Önizleme
                  </label>
                  <div className="flex justify-center">
                    <QRCodeCanvas value={qrPreview} size={200} />
                  </div>
                  <p className="text-xs text-gray-500 text-center mt-2">
                    {qrPreview}
                  </p>
                </div>
              )}

              <div className="flex justify-between">
                <button
                  type="button"
                  onClick={() => navigate('/dashboard')}
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                >
                  {loading ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AnswerForm;